export default "__VITE_ASSET__6d11c1ec__"